import { render, staticRenderFns } from "./DetailMTutorial.vue?vue&type=template&id=4c0d6160&scoped=true&lang=pug&"
import script from "./DetailMTutorial.vue?vue&type=script&lang=js&"
export * from "./DetailMTutorial.vue?vue&type=script&lang=js&"
import style0 from "./DetailMTutorial.vue?vue&type=style&index=0&id=4c0d6160&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0d6160",
  null
  
)

export default component.exports